(function () {
    function initDrawer(wrapper) {
        const drawer = wrapper.querySelector('.swyft-variant-drawer');
        const panel = drawer?.querySelector('.swyft-variant-drawer__panel');
        const btnOpen = wrapper.querySelector('[data-action="open-variant-drawer"]');
        const btnClose = drawer?.querySelector('[data-action="close-variant-drawer"]');
        const backdrop = drawer?.querySelector('.swyft-variant-drawer__backdrop');
        const btnConfirms = Array.from(drawer?.querySelectorAll('[data-action="confirm-variant-selection"]') || []);
        const selectsRootId = wrapper.getAttribute('data-variant-selects-id');
        const selectsRoot = selectsRootId ? document.getElementById(selectsRootId) : null;
        const selectedScriptEl = selectsRoot?.querySelector('[data-selected-variant]');
        const optionIndex = Number.parseInt(wrapper.getAttribute('data-option-index') || '0', 10) || 0;
        const summaryRefs = btnOpen ? {
            button: btnOpen,
            label: btnOpen.querySelector('[data-picker-label]') || null,
            colour: btnOpen.querySelector('[data-picker-colour]') || null,
            material: btnOpen.querySelector('[data-picker-material]') || null,
            stock: btnOpen.querySelector('[data-picker-stock]') || null,
            delivery: btnOpen.querySelector('[data-picker-delivery]') || null,
            swatchImg: btnOpen.querySelector('[data-picker-swatch-img]') || null,
            swatchFallback: btnOpen.querySelector('[data-picker-swatch-fallback]') || null,
        } : null;
        if (!drawer || !btnOpen) return;

        const cartRoot = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

        const renderCartFromResponse = (response) => {
            if (!cartRoot || typeof cartRoot.renderContents !== 'function') return;
            if (!response || !response.sections) return;
            cartRoot.dataset.suppressOpen = 'true';
            try {
                cartRoot.renderContents(response);
            } finally {
                // renderContents clears the attribute when it runs; make sure it's gone if render throws.
                cartRoot.removeAttribute('data-suppress-open');
            }
            cartRoot.classList?.remove?.('is-empty');
        };

        const refreshCartSections = () => {
            if (!cartRoot || typeof cartRoot.getSectionsToRender !== 'function' || typeof cartRoot.renderContents !== 'function') {
                return Promise.resolve();
            }
            const sections = cartRoot.getSectionsToRender();
            if (!Array.isArray(sections) || !sections.length) {
                return Promise.resolve();
            }
            const sectionIds = sections.map((section) => section.id).join(',');
            if (!sectionIds) {
                return Promise.resolve();
            }
            return fetch(`${routes.cart_url}?sections=${sectionIds}`, { credentials: 'same-origin' })
                .then((response) => response.json())
                .then((sectionsHtml) => {
                    renderCartFromResponse({ id: '', sections: sectionsHtml });
                })
                .catch(() => {});
        };

        const parseStockData = (value) => {
            if (!value) return null;
            try {
                return JSON.parse(value);
            } catch (err) {
                return null;
            }
        };

        const getAvailabilitySnapshot = (li) => {
            if (!li) return {
                stockData: null,
                stockJson: '',
                stockQty: '',
                stockLabel: '',
                firstAvailableDate: '',
            };

            const availabilityEl = li.querySelector('item-availability');
            if (!availabilityEl) {
                return {
                    stockData: null,
                    stockJson: '',
                    stockQty: '',
                    stockLabel: '',
                    firstAvailableDate: '',
                };
            }

            const snapshot = {
                stockData: null,
                stockJson: availabilityEl.dataset.stock || '',
                stockQty: '',
                stockLabel: '',
                firstAvailableDate: availabilityEl.dataset.firstAvailableDate || '',
                notifyText: availabilityEl.dataset.notifyText || '',
                outOfStockText: availabilityEl.dataset.outOfStockText || '',
            };

            snapshot.stockData = parseStockData(snapshot.stockJson);

            const stockQtyCandidate = typeof snapshot.stockData?.stock !== 'undefined'
                ? Number(snapshot.stockData.stock)
                : Number(availabilityEl.dataset.stockQty);

            if (!Number.isNaN(stockQtyCandidate)) {
                snapshot.stockQty = String(stockQtyCandidate);
            }

            const numericQty = Number(snapshot.stockQty);
            const hasFutureDate = snapshot.firstAvailableDate && snapshot.firstAvailableDate !== '';

            if (!Number.isNaN(numericQty) && numericQty > 0) {
                snapshot.stockLabel = `${numericQty} available`;
            } else if (!hasFutureDate) {
                snapshot.stockLabel = snapshot.notifyText || snapshot.outOfStockText || '';
            } else {
                snapshot.stockLabel = snapshot.outOfStockText || '';
            }

            const deliveryEl = availabilityEl.querySelector('[data-message="delivery"]');
            snapshot.deliveryText = deliveryEl ? deliveryEl.textContent.trim() : '';

            return snapshot;
        };

        const refreshDeliveryComponent = (container, state = {}) => {
            if (!container) return;
            const availabilityEl = container.querySelector('item-availability');
            if (!availabilityEl) {
                if (state.deliveryText !== undefined) {
                    container.innerHTML = state.deliveryText || '';
                }
                return;
            }

            const overrides = {
                showCutoffMessage: false,
                showStockMessage: false,
            };

            if (state.stockData) {
                overrides.stockData = state.stockData;
            } else if (state.stockJson) {
                const parsed = parseStockData(state.stockJson);
                if (parsed) overrides.stockData = parsed;
            }

            if (typeof state.stockQty !== 'undefined' && state.stockQty !== '') {
                const parsedQty = Number(state.stockQty);
                if (!Number.isNaN(parsedQty)) overrides.stockQty = parsedQty;
            }

            if (state.firstAvailableDate !== undefined && state.firstAvailableDate !== null) {
                overrides.firstAvailableDate = state.firstAvailableDate;
            }

            if (availabilityEl.refresh) {
                availabilityEl.refresh(overrides);
            } else {
                if (overrides.stockData) {
                    availabilityEl.dataset.stock = JSON.stringify(overrides.stockData);
                }
                if (typeof overrides.stockQty !== 'undefined') {
                    availabilityEl.dataset.stockQty = overrides.stockQty;
                }
                if (overrides.firstAvailableDate !== undefined) {
                    availabilityEl.dataset.firstAvailableDate = overrides.firstAvailableDate || '';
                }
                availabilityEl.connectedCallback?.();
            }
        };

        if (drawer.parentElement !== document.body) {
            const anchor = document.createComment('swyft-variant-drawer-anchor');
            drawer.dataset.anchor = 'true';
            wrapper.insertBefore(anchor, drawer);
            document.body.appendChild(drawer);
        }

        const findLiForVariant = (variant) => {
            if (!variant) return null;
            let activeLi = null;
            drawer.querySelectorAll('.swyft-variant-drawer__item').forEach((li) => {
                let match = true;
                for (let i = 1; i <= 3; i++) {
                    const opt = variant[`option${i}`];
                    const liOpt = li.dataset[`option${i}`];
                    if (opt && liOpt && liOpt !== opt) {
                        match = false;
                        break;
                    }
                }
                if (match) activeLi = li;
            });
            return activeLi;
        };

        function updateVariantCount() {
            if (!drawer) return;
            const allItems = Array.from(drawer.querySelectorAll('.swyft-variant-drawer__item'))
                .filter(li => li.style.display !== 'none');
            const backorderItems = allItems.filter(li => li.classList.contains('backorder'));
            const count = allItems.length - backorderItems.length;
            const countEl = summaryRefs?.button?.querySelector('#variant-count');
            const labelEl = summaryRefs?.button?.querySelector('#variant-count-label');
            if (countEl) countEl.textContent = count;
            if (labelEl) {
                labelEl.classList.toggle('is-visible', count > 0);
                if (labelEl.style.visibility) {
                    labelEl.style.removeProperty('visibility');
                }
            }
        }

        const swatchButtons = Array.from(drawer.querySelectorAll('[data-action="add-swatch"]'));
        const swatchCounters = Array.from(drawer.querySelectorAll('[data-swatch-count]'));
        const swatchMax = Number(wrapper.dataset.swatchMax || '6');
        const sampleVariantIdCandidate = Number(wrapper.dataset.swatchSampleVariant || '0');
        const sampleVariantId = Number.isNaN(sampleVariantIdCandidate) ? 0 : sampleVariantIdCandidate;
        const swatchInterestProductId = (wrapper.dataset.productId || '').trim();
        const swatchInterestProductTitle = (wrapper.dataset.productTitle || '').trim();

        const parseSwatchVariantId = (raw) => {
            const parsed = Number(raw);
            return Number.isNaN(parsed) || parsed <= 0 ? null : parsed;
        };

    const swatchVariantIds = new Set();
    const sampleHandles = new Set(['swatch-request', 'made-to-order-swyft-swatch-box']);
    const swatchBoxKeyword = 'SWATCH-BOX';
        swatchButtons.forEach((btn) => {
            const id = parseSwatchVariantId(btn.dataset.swatchVariantId);
            if (id) {
                swatchVariantIds.add(id);
            }
        });

        const swatchState = {
            total: 0,
            quantities: new Map(),
            sampleQuantity: 0,
        };

        // In-flight add guards. The swatch quantities Map only updates once the
        // cart add resolves, so without these a swatch shown in more than one row
        // (or a rapid double activation) can be POSTed twice before the first
        // response lands, duplicating the swatch line or the shared sample box.
        const pendingSwatchVariantIds = new Set();
        let samplePending = false;

        const getButtonLabel = (btn, state) => {
            const { isUnavailable, isLoading, alreadyAdded, maxReached } = state;

            if (isLoading) {
                return btn.dataset.swatchLabelLoading || 'Adding…';
            }
            if (isUnavailable) {
                return btn.dataset.swatchLabelUnavailable || 'Swatch unavailable';
            }
            if (alreadyAdded) {
                return btn.dataset.swatchLabelRemove || 'Remove swatch';
            }
            if (maxReached) {
                return btn.dataset.swatchLabelMax || 'Max swatches reached';
            }
            return btn.dataset.swatchLabelAdd || 'Add swatch';
        };

        const getCounterLabel = (total) => {
            if (total <= 0) {
                return `Up to ${swatchMax} FREE`;
            }
            return `Swatches: ${total}/${swatchMax}`;
        };

        const renderSwatchState = () => {
            const counterLabel = getCounterLabel(swatchState.total);
            const isFull = swatchState.total >= swatchMax;
            swatchCounters.forEach((counter) => {
                let valueEl = counter.querySelector('[data-swatch-count-value]');
                if (!valueEl) {
                    valueEl = document.createElement('span');
                    valueEl.dataset.swatchCountValue = '';
                    while (counter.firstChild) {
                        counter.removeChild(counter.firstChild);
                    }
                    counter.appendChild(valueEl);
                }

                counter.classList.toggle('is-max', isFull);

                const existingEditLink = counter.querySelector('[data-action="select-samples"]');
                const fullLabel = counter.dataset.swatchCountFullLabel || 'Swatch box full';
                const editLabel = counter.dataset.swatchCountEditLabel || 'Edit swatch box';

                if (swatchState.total > 0) {
                    valueEl.textContent = isFull ? fullLabel : counterLabel;

                    let editLink = existingEditLink;
                    if (!editLink) {
                        editLink = document.createElement('a');
                        editLink.href = '#select-samples';
                        editLink.dataset.action = 'select-samples';
                        editLink.className = 'swd-row__swatch-edit';
                        counter.appendChild(editLink);
                    }
                    editLink.textContent = editLabel;
                    editLink.hidden = false;
                } else {
                    valueEl.textContent = counterLabel;
                    if (existingEditLink) {
                        existingEditLink.remove();
                    }
                }
            });

            swatchButtons.forEach((btn) => {
                const variantId = parseSwatchVariantId(btn.dataset.swatchVariantId);
                const alreadyAdded = variantId ? (swatchState.quantities.get(variantId) || 0) > 0 : false;
                const isUnavailable = !variantId;
                const isLoading = btn.dataset.state === 'loading';
                const maxReached = swatchState.total >= swatchMax && !alreadyAdded;

                const nextLabel = getButtonLabel(btn, { isUnavailable, isLoading, alreadyAdded, maxReached });

                const shouldDisable = isLoading || (!alreadyAdded && (isUnavailable || maxReached));
                btn.disabled = shouldDisable;

                btn.classList.toggle('is-disabled', shouldDisable && !alreadyAdded);
                btn.classList.toggle('is-loading', isLoading);
                btn.classList.toggle('is-added', alreadyAdded);
                btn.classList.toggle('is-hidden', maxReached && !alreadyAdded);
                btn.setAttribute('aria-pressed', alreadyAdded ? 'true' : 'false');

                if (btn.textContent.trim() !== nextLabel) {
                    btn.textContent = nextLabel;
                }
            });
        };

        const setSwatchStateFromCart = (cart) => {
            const nextQuantities = new Map();
            let total = 0;
            let sampleQty = 0;
            if (cart && Array.isArray(cart.items)) {
                cart.items.forEach((item) => {
                    const variantId = Number(item.variant_id || item.id || item.variantId);
                    const quantity = Number(item.quantity) || 0;
                    if (Number.isNaN(variantId) || quantity <= 0) {
                        return;
                    }

                    const handle = (item.handle || '').toLowerCase();
                    const sku = (item.sku || '').toUpperCase();
                    const isSampleHandle = sampleHandles.has(handle);
                    const isSwatchBoxSku = sku.includes(swatchBoxKeyword);
                    const isSwatchSku = sku.includes('SWATCH') && !isSwatchBoxSku;
                    const isDrawerSwatch = swatchVariantIds.has(variantId);
                    const isSwatchItem = isDrawerSwatch || isSwatchSku || (isSampleHandle && !isSwatchBoxSku);

                    if (isDrawerSwatch) {
                        nextQuantities.set(variantId, (nextQuantities.get(variantId) || 0) + quantity);
                    }

                    if (isSwatchItem) {
                        total += quantity;
                    }

                    if (sampleVariantId && variantId === sampleVariantId) {
                        sampleQty += quantity;
                    }
                });
            }
            swatchState.total = total;
            swatchState.quantities = nextQuantities;
            swatchState.sampleQuantity = sampleQty;
            renderSwatchState();
        };

        const fetchCartState = () => {
            return fetch('/cart.js', { credentials: 'same-origin' })
                .then((response) => response.ok ? response.json() : Promise.reject(new Error('Cart request failed')));
        };

        const refreshSwatchState = () => {
            if (!swatchButtons.length || !swatchVariantIds.size) return;
            fetchCartState()
                .then((cart) => {
                    setSwatchStateFromCart(cart);
                })
                .catch(() => {
                    renderSwatchState();
                });
        };

        const handleAddSwatch = (button) => {
            const variantId = parseSwatchVariantId(button.dataset.swatchVariantId);
            if (!variantId) return;

            // Block a concurrent add of the same swatch while one is already in
            // flight, so two activations can't create a duplicate line for it.
            if (pendingSwatchVariantIds.has(variantId)) return;

            const alreadyAdded = Boolean(swatchState.quantities.get(variantId));

            if (alreadyAdded) {
                return removeSwatch(variantId, button);
            }

            if (swatchState.total >= swatchMax) {
                renderSwatchState();
                return;
            }

            pendingSwatchVariantIds.add(variantId);
            button.dataset.state = 'loading';
            button.disabled = true;
            button.classList.add('is-loading');
            const labelLoading = button.dataset.swatchLabelLoading || 'Adding…';
            button.textContent = labelLoading;

            const payloadItems = [];
            if (sampleVariantId && swatchState.sampleQuantity < 1 && !samplePending) {
                samplePending = true;
                payloadItems.push({
                    id: sampleVariantId,
                    quantity: 1 - Math.max(0, swatchState.sampleQuantity),
                });
            }
            const swatchItem = { id: variantId, quantity: 1 };
            if (swatchInterestProductId || swatchInterestProductTitle) {
                swatchItem.properties = {};
                if (swatchInterestProductId) {
                    swatchItem.properties._interest_product_id = swatchInterestProductId;
                }
                if (swatchInterestProductTitle) {
                    swatchItem.properties._interest_product_title = swatchInterestProductTitle;
                }
            }
            payloadItems.push(swatchItem);

            const config = (typeof fetchConfig === 'function' ? fetchConfig('javascript') : null) || { method: 'POST', headers: {} };
            config.headers = config.headers || {};
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];

            const formData = new FormData();
            payloadItems.forEach((item, index) => {
                formData.append(`items[${index}][id]`, item.id);
                formData.append(`items[${index}][quantity]`, item.quantity);
                if (item.properties && typeof item.properties === 'object') {
                    Object.entries(item.properties).forEach(([propKey, propValue]) => {
                        if (propValue !== undefined && propValue !== null && propValue !== '') {
                            formData.append(`items[${index}][properties][${propKey}]`, propValue);
                        }
                    });
                }
            });

            if (cartRoot && typeof cartRoot.getSectionsToRender === 'function') {
                const sections = cartRoot.getSectionsToRender();
                if (Array.isArray(sections) && sections.length) {
                    formData.append('sections', sections.map((section) => section.id));
                }
                formData.append('sections_url', window.location.pathname);
                if (typeof cartRoot.setActiveElement === 'function') {
                    cartRoot.setActiveElement(document.activeElement);
                }
            }

            config.body = formData;

            fetch(`${routes.cart_add_url}`, config)
                .then((response) => response.json())
                .then((response) => {
                    if (response.status) {
                        return Promise.reject(response);
                    }
                    renderCartFromResponse(response);
                    return fetchCartState();
                })
                .then((cart) => {
                    setSwatchStateFromCart(cart);
                    // Record the viewed product against Klaviyo (no-op off a PDP).
                    window.trackSwatchInterest?.();
                    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'variant-drawer-swatch', cartData: cart });
                    }
                })
                .catch((error) => {
                    console.error('Failed to add swatch', error);
                    button.textContent = button.dataset.swatchLabelAdd || 'Add swatch';
                    if (error?.errors || error?.message) {
                        publish?.(PUB_SUB_EVENTS.cartError, {
                            source: 'variant-drawer-swatch',
                            errors: error.errors,
                            message: error.message,
                        });
                    }
                })
                .finally(() => {
                    pendingSwatchVariantIds.delete(variantId);
                    samplePending = false;
                    delete button.dataset.state;
                    button.disabled = false;
                    button.classList.remove('is-loading');
                    renderSwatchState();
                    refreshCartSections();
                });
        };

        const removeSwatch = (variantId, button) => {
            if (!variantId) return;

            const updates = { [variantId]: 0 };
            if (sampleVariantId && swatchState.total <= 1) {
                updates[sampleVariantId] = 0;
            }

            button.dataset.state = 'loading';
            button.disabled = true;
            button.classList.add('is-loading');
            const removingLabel = button.dataset.swatchLabelRemoving || 'Removing…';
            button.textContent = removingLabel;

            fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                },
                credentials: 'same-origin',
                body: JSON.stringify({ updates }),
            })
                .then((response) => {
                    if (!response.ok) {
                        return response.json().then((err) => Promise.reject(err));
                    }
                    return response.json();
                })
                .then((cart) => {
                    setSwatchStateFromCart(cart);
                    refreshCartSections();
                    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'variant-drawer-swatch-remove', cartData: cart });
                    }
                })
                .catch((error) => {
                    console.error('Failed to remove swatch', error);
                    button.textContent = button.dataset.swatchLabelRemove || 'Remove swatch';
                })
                .finally(() => {
                    delete button.dataset.state;
                    button.disabled = false;
                    button.classList.remove('is-loading');
                    renderSwatchState();
                });
        };

        if (swatchButtons.length) {
            renderSwatchState();
            refreshSwatchState();

            if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
                    if (event?.source === 'variant-drawer-swatch') {
                        return;
                    }
                    if (event?.cartData) {
                        setSwatchStateFromCart(event.cartData);
                    } else {
                        refreshSwatchState();
                    }
                });
            }

            drawer.addEventListener('click', (event) => {
                const swatchBtn = event.target.closest('[data-action="add-swatch"]');
                if (!swatchBtn) return;
                event.preventDefault();
                event.stopPropagation();
                handleAddSwatch(swatchBtn);
            });
        }

        const applySummaryState = (state = {}) => {
            if (!summaryRefs) return;
            const { button, label, colour, material, stock, delivery, swatchImg, swatchFallback } = summaryRefs;
            const optionLabel = button.dataset.optionLabel || label?.textContent || '';
            const optionValue = state.optionValue !== undefined ? state.optionValue : (button.dataset.optionValue || '');

            const existingDataset = button.dataset || {};
            const resolvedStockJson = state.stockJson !== undefined ? state.stockJson : (existingDataset.stockJson || '');
            const resolvedFirstAvailable = state.firstAvailableDate !== undefined ? state.firstAvailableDate : (existingDataset.firstAvailableDate || '');
            const resolvedStockQty = state.stockQty !== undefined ? state.stockQty : (existingDataset.stockQty || '');
            const resolvedStockData = state.stockData || parseStockData(resolvedStockJson);

            const resolvedState = {
                ...state,
                stockJson: resolvedStockJson,
                firstAvailableDate: resolvedFirstAvailable,
                stockQty: resolvedStockQty,
                stockData: resolvedStockData,
                notifyText: state.notifyText || existingDataset.notifyText || '',
                outOfStockText: state.outOfStockText || existingDataset.outOfStockText || '',
            };

            if (colour) {
                colour.textContent = optionValue || '';
            }

            if (material) {
                material.textContent = resolvedState.materialName ? `${resolvedState.materialName}` : '';
            }

            if (!resolvedState.stockLabel && resolvedState.stockData) {
                const qty = Number(resolvedState.stockQty);
                const notifyText = resolvedState.notifyText || '';
                const outOfStockText = resolvedState.outOfStockText || '';
                if (!Number.isNaN(qty) && qty > 0) {
                    resolvedState.stockLabel = `${qty} available`;
                } else if (!resolvedState.firstAvailableDate) {
                    resolvedState.stockLabel = notifyText || outOfStockText || '';
                } else {
                    resolvedState.stockLabel = outOfStockText || '';
                }
            }

            if (stock) {
                stock.textContent = resolvedState.stockLabel || '';
            }

            if (delivery) {
                refreshDeliveryComponent(delivery, resolvedState);
            }

            if (swatchImg) {
                if (resolvedState.swatchImage) {
                    swatchImg.src = resolvedState.swatchImage;
                    swatchImg.hidden = false;
                    if (swatchFallback) swatchFallback.hidden = true;
                } else {
                    swatchImg.hidden = true;
                    if (swatchFallback) swatchFallback.hidden = false;
                }
            }

            button.dataset.stockQty = resolvedState.stockQty !== undefined ? resolvedState.stockQty : '';
            button.dataset.materialName = resolvedState.materialName || '';
            button.dataset.optionValue = optionValue || '';
            button.dataset.stockLabel = resolvedState.stockLabel || '';
            button.dataset.stockJson = resolvedState.stockJson || '';
            if (resolvedState.notifyText) {
                button.dataset.notifyText = resolvedState.notifyText;
            }
            if (resolvedState.outOfStockText) {
                button.dataset.outOfStockText = resolvedState.outOfStockText;
            }
            if (resolvedState.firstAvailableDate !== undefined) {
                button.dataset.firstAvailableDate = resolvedState.firstAvailableDate || '';
            }
            if (resolvedState.swatchImage !== undefined) {
                button.dataset.swatchImage = resolvedState.swatchImage || '';
            }
            // No aria-label: the button is named by its visible text, which the summary keeps up to date.
            button.removeAttribute('aria-label');

        };

        const updateSummaryFromLi = (li) => {
            if (!li || !summaryRefs) return;
            const optionKey = `option${Math.min(optionIndex + 1, 3)}`;
            const optionValue = li.dataset[optionKey] || '';
            const availability = getAvailabilitySnapshot(li);
            applySummaryState({
                optionValue,
                materialName: li.dataset.materialName || '',
                stockLabel: availability.stockLabel,
                stockQty: availability.stockQty,
                swatchImage: li.dataset.swatchImage || '',
                stockJson: availability.stockJson,
                stockData: availability.stockData,
                firstAvailableDate: availability.firstAvailableDate || '',
                notifyText: availability.notifyText,
                outOfStockText: availability.outOfStockText
            });
        };

        const getSelectedVariantFromScript = () => {
            try {
                const payload = selectedScriptEl?.textContent?.trim();
                return payload ? JSON.parse(payload) : null;
            } catch (_) {
                return null;
            }
        };

        const syncSummaryFromSelectedVariant = () => {
            const variant = getSelectedVariantFromScript();
            const li = findLiForVariant(variant);
            if (li) {
                updateSummaryFromLi(li);
            } else if (variant) {
                const optionKey = `option${Math.min(optionIndex + 1, 3)}`;
                applySummaryState({ optionValue: variant[optionKey] || '' });
            }
        };

        const setSelectedRow = (li) => {
            drawer.querySelectorAll('.swyft-variant-drawer__item.is-selected').forEach(el => el.classList.remove('is-selected'));
            if (li) {
                li.classList.add('is-selected');
                btnConfirms.forEach(btn => btn.removeAttribute('disabled'));
                drawer.dataset.selectedVariantId = li.dataset.variantId || '';
            } else {
                btnConfirms.forEach(btn => btn.setAttribute('disabled', 'true'));
                delete drawer.dataset.selectedVariantId;
            }
        };

        const open = () => {
            // Preselect current variant in list
            try {
                const current = getSelectedVariantFromScript();
                if (current) {
                    const activeLi = findLiForVariant(current);
                    setSelectedRow(activeLi || null);
                    // Update hero image to selected variant's featured image
                    if (activeLi) {
                        const heroImg = drawer.querySelector('.swyft-variant-drawer__hero-img');
                        const featuredImgUrl = activeLi.dataset.featuredImage;
                        if (heroImg && featuredImgUrl) {
                            heroImg.src = featuredImgUrl;
                            heroImg.srcset = featuredImgUrl;
                        }
                        updateSummaryFromLi(activeLi);
                    }
                }
            } catch (_) { }

            // Count visible variants and update #variant-count
            updateVariantCount();

            drawer.hidden = false;
            drawer.classList.remove('is-open');
            void (panel && panel.offsetWidth);
            requestAnimationFrame(() => {
                drawer.classList.add('is-open');
            });
            document.body.style.overflow = 'hidden';
            setTimeout(() => { panel?.focus(); }, 0);
        };

        const close = () => {
            drawer.classList.remove('is-open');
            setTimeout(() => { drawer.hidden = true; }, 480);
            document.body.style.overflow = '';
        };

        btnOpen.addEventListener('click', open);
        btnClose?.addEventListener('click', close);
        backdrop?.addEventListener('click', close);

        drawer.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') close();
        });

        // Row selection (do not immediately apply)
        drawer.addEventListener('click', (e) => {
            const rowBtn = e.target.closest('.swyft-variant-drawer__row');
            if (rowBtn) {
                const li = rowBtn.closest('.swyft-variant-drawer__item');
                setSelectedRow(li);
                // Update hero image to selected variant's featured image
                const heroImg = drawer.querySelector('.swyft-variant-drawer__hero-img');
                const featuredImgUrl = li.dataset.featuredImage;
                if (heroImg && featuredImgUrl) {
                    heroImg.src = featuredImgUrl;
                    heroImg.srcset = featuredImgUrl;
                }
            }
        });

        // Confirm applies selection to hidden selects
        btnConfirms.forEach(btn => {
            btn.addEventListener('click', () => {
                // Find the correct variant based on selected row and product options
                const li = drawer.querySelector('.swyft-variant-drawer__item.is-selected');
                if (!li || !selectsRoot) { close(); return; }
                const selects = selectsRoot.querySelectorAll('select[name^="options["]');
                // Only set the select for the option the drawer is for
                if (selects[0]) {
                    const optionKey = `option${Math.min(optionIndex + 1, 3)}`;
                    const val = li.dataset[optionKey];
                    if (val && selects[0].value !== val && Array.from(selects[0].options).some(o => o.value === val)) {
                        selects[0].value = val;
                        selects[0].dispatchEvent(new Event('input', { bubbles: true }));
                        selects[0].dispatchEvent(new Event('change', { bubbles: true }));
                    }
                }
                updateSummaryFromLi(li);
                close();
            });
        });

        // Simple filters
        const filterBar = drawer.querySelector('.swyft-variant-drawer__filters');
        const applyFilters = () => {
            if (!drawer) return;
            const colour = filterBar?.querySelector('[data-filter="colour-group"]').value || '';
            const material = filterBar?.querySelector('[data-filter="material"]').value || '';
            drawer.querySelectorAll('.swyft-variant-drawer__item').forEach((li) => {
                const matchColour = !colour || (li.dataset.colour || '').toLowerCase().includes(`|${colour.toLowerCase()}|`);
                const matchMaterial = !material || (li.dataset.material || '').toLowerCase() === material.toLowerCase();
                li.style.display = (matchColour && matchMaterial) ? '' : 'none';
            });

            // Hide group header/section if all items are filtered out
            drawer.querySelectorAll('.swyft-variant-drawer__group').forEach((section) => {
                const visibleItems = Array.from(section.querySelectorAll('.swyft-variant-drawer__item')).filter(li => li.style.display !== 'none');
                section.style.display = visibleItems.length > 0 ? '' : 'none';
            });

        };
        if (filterBar) {
            // Permanently set first option text to 'All xxxx'
            filterBar.querySelectorAll('select').forEach(sel => {
                const firstOption = sel.options[0];
                const baseText = firstOption.textContent.replace(/^All /, '');
                firstOption.textContent = 'All ' + baseText;
            });
            // iOS Safari select blur workaround (touchend)
            filterBar.addEventListener('change', applyFilters);
            // Detect touch to open a select and blur all others
            filterBar.querySelectorAll('select').forEach(sel => {
                sel.addEventListener('touchstart', function () {
                    filterBar.querySelectorAll('select').forEach(other => {
                        if (other !== sel) other.blur();
                    });
                });
            });
        }

        syncSummaryFromSelectedVariant();
        updateVariantCount();

        if (selectedScriptEl) {
            const observer = new MutationObserver(() => {
                syncSummaryFromSelectedVariant();
            });
            observer.observe(selectedScriptEl, { characterData: true, childList: true, subtree: true });
        }
    }

    function initAll() {
        document.querySelectorAll('.swyft-variant-drawer-wrapper').forEach(initDrawer);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAll);
    } else {
        initAll();
    }
})();

